import * as Sentry from "@sentry/react";

export const ERROR_MSG_CART_FETCH = "unable to retrieve shopify cart";

let sentryInitialized = false;
function init() {
  Sentry.init({
    // Disable sentry if not deployed on live site
    enabled: JSON.parse(process.env.SENTRY_ENABLED ?? "false"),

    // Having DSN in repo is fine: https://forum.sentry.io/t/dsn-private-public/6297/2
    dsn: "https://2e9a98f2905144e080e1e93f510582fd@o4503921545773056.ingest.sentry.io/4503921547870208",

    // Disable reporting performance data until we can evaluate cost
    tracesSampleRate: 0.0,

    ignoreErrors: [
      // ignore noisy errors: https://stackoverflow.com/a/60860369/433785
      "TypeError: Failed to fetch",
      "TypeError: NetworkError when attempting to fetch resource.",
      "TypeError: cancelled",
      "TypeError: Load failed",

      // Ignore some privacy errors from 3rd party scripts
      /sandboxed and lacks the 'allow-same-origin' flag/,

      // Ignore errors arising from ad-blockers
      // https://github.com/getsentry/sentry-javascript/issues/2546#issuecomment-863948520
      /Non-Error promise rejection captured with/,
    ],

    beforeSend(event, hint) {
      const exc = event.exception?.values?.[0];

      // I don't want to see errors originating from klaviyo
      if (
        exc?.stacktrace?.frames?.some((x) =>
          x.abs_path?.includes("klaviyo.com")
        )
      ) {
        return null;
      }

      // Ignore errors from google's crawler.
      if (event.tags?.["browser.name"] === "Googlebot") {
        return null;
      }

      return event;
    },
  });

  sentryInitialized = true;
}

export function initSentry() {
  try {
    init();
  } catch (ex) {
    console.error("unable to initialize sentry", ex);
  }
}

export function handleError(e: unknown, msg?: string) {
  if (msg) {
    console.error(msg, e);
  } else {
    console.error(e);
  }

  if (!sentryInitialized) {
    return;
  }

  // Ignore errors from cancelled fetches due to a redirect
  if (msg === ERROR_MSG_CART_FETCH) {
    return;
  }

  Sentry.captureException(e, (scope) => {
    // Use a better error name if one is available:
    // ref: https://stackoverflow.com/a/72140821/433785
    if (msg) {
      scope.setTransactionName(msg);
    }
    return scope;
  });
}
